import { TemplateRef } from '@angular/core';
import { COLUMN_IDENTIFIERS } from '../../../pages/employee-flow/const';

/** Header of the combined Request column (subject, with the ID and workflow type under it). */
export const REQUEST_SUMMARY_COLUMN_HEADER = 'inbox_request_column_header';

const MERGED_INTO_REQUEST_SUMMARY: string[] = [
  COLUMN_IDENTIFIERS.NAME,
  COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
];

/**
 * UI_Version_2: the ID, workflow type and subject columns become one Request column.
 * It keeps the ID column's place, sort key and view icon; the other two are dropped.
 */
export function mergeRequestSummaryColumns<
  T extends { header: string; identifier?: string },
>(columns: T[], enabled: boolean): T[] {
  if (!enabled) {
    return columns;
  }
  return columns
    .filter(
      column => !MERGED_INTO_REQUEST_SUMMARY.includes(column.identifier ?? '')
    )
    .map(column =>
      column.identifier === COLUMN_IDENTIFIERS.ID
        ? { ...column, header: REQUEST_SUMMARY_COLUMN_HEADER }
        : column
    );
}

/** The cell templates matching mergeRequestSummaryColumns, in the same order. */
export function mergeRequestSummaryTemplates<
  T extends { identifier?: string; template: TemplateRef<unknown> },
>(
  templates: T[],
  enabled: boolean,
  summaryTemplate: TemplateRef<unknown>
): T[] {
  if (!enabled) {
    return templates;
  }
  return templates
    .filter(
      item => !MERGED_INTO_REQUEST_SUMMARY.includes(item.identifier ?? '')
    )
    .map(item =>
      item.identifier === COLUMN_IDENTIFIERS.ID
        ? { ...item, template: summaryTemplate }
        : item
    );
}
